import { BrowserCacheLocation, Configuration } from "@azure/msal-browser";

// Ensure environment variables are defined
const requiredEnvVars = {
  clientId: process.env.REACT_APP_AZURE_CLIENT_ID,
  tenantId: process.env.REACT_APP_AZURE_TENANT_ID,
  redirectUri: process.env.REACT_APP_AUTH_REDIRECT_URI,
  apiUrl: process.env.REACT_APP_API_URL,
  apiScope: process.env.REACT_APP_API_SCOPE,
};

// Validate required environment variables
Object.entries(requiredEnvVars).forEach(([key, value]) => {
  if (!value) {
    console.warn(
      `Missing required environment variable: REACT_APP_${key.toUpperCase()}`
    );
  }
});

// Config object to be passed to Msal on creation
export const msalConfig: Configuration = {
  auth: {
    clientId: requiredEnvVars.clientId || "",
    authority: `https://login.microsoftonline.com/${
      requiredEnvVars.tenantId || ""
    }`,
    redirectUri: requiredEnvVars.redirectUri,
    knownAuthorities: ["login.microsoftonline.com"],
    navigateToLoginRequestUrl: false,
  },
  cache: {
    cacheLocation: BrowserCacheLocation.SessionStorage,
    storeAuthStateInCookie: true,
    secureCookies: false, // Set to true if using HTTPS
    temporaryCacheLocation: BrowserCacheLocation.SessionStorage,
    claimsBasedCachingEnabled: true,
  },
  system: {
    allowNativeBroker: false,
    iframeHashTimeout: 30000,
    loadFrameTimeout: 30000,
    asyncPopups: true,
    windowHashTimeout: 30000,
    navigateFrameWait: 30000,
    tokenRenewalOffsetSeconds: 300, // Renew tokens 5 minutes before expiry
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) return;
        
        switch (level) {
          case 0: // Error
            console.error(message);
            break;
          case 1: // Warning
            console.warn(message);
            break;
          case 2: // Info
            console.info(message);
            break;
          default:
            console.log(message);
            break;
        }
      },
      piiLoggingEnabled: false,
    },
  },
};

export const loginRequest = {
  scopes: [requiredEnvVars.apiScope].filter((s): s is string => !!s),
  // Removed explicit select_account prompt to avoid duplicate prompts.
  extraScopesToConsent: ["openid", "profile", "email"],
};

export const graphConfig = {
  graphMeEndpoint: "https://graph.microsoft.com/v1.0/me",
  graphPhotoEndpoint: "https://graph.microsoft.com/v1.0/me/photo/$value",
};

export const apiConfig = {
  baseUrl: requiredEnvVars.apiUrl,
  scopes: [requiredEnvVars.apiScope].filter((s): s is string => !!s),
};
